import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { DispatchBoardPanels } from "../../../shared/enums/DispatchBoardPanels";
import { DispatchBoardSearch } from '../../../shared/models/DispatchBoardSearch';
import { GlobalsService } from '../../../shared/services/globals.service';
import { DispatchBoardService } from '../../../shared/services/dispatch-board.service';
import { addDays } from '@progress/kendo-date-math';
import { Subscription } from 'rxjs';
import { CommonFunctions } from '@app/cp/shared/static/common-functions';
import { DispatchAssignmentBus } from '@app/cp/shared/models/DispatchAssignmentBus';
import { v_DispatchBus } from '@app/cp/shared/models/v_DispatchBus';
import { WindowContents } from '../../../shared/enums/windowContents';
import { v_DispatchGrid2Bus } from '@app/cp/shared/models/v_DispatchGrid2Bus';
import { UsersBus } from '@app/cp/shared/models/UsersBus.model';
import { CmProAuthService } from '@app/core/services';
import { CommonValues } from '@app/cp/shared/static/CommonValues';

@Component({
    selector: 'cp-tech-panel-detail',
    templateUrl: './tech-panel-detail.component.html',
    styleUrls: ['./tech-panel-detail.component.scss']
})
export class TechPanelDetailComponent implements OnInit, OnDestroy {

    subscriptions: Subscription[] = [];

    constructor(private svc_globals: GlobalsService, private svc_data: DispatchBoardService, private authService: CmProAuthService) {
        this.subscriptions.push(svc_data.hoverTechPanel$.subscribe(
            hover => {
                if (hover != null) {
                }
            }));
        this.subscriptions.push(svc_data.refreshTrigger$.subscribe(
            refresh => {
                this.initData();
            }));
        this.subscriptions.push(svc_data.selectedDispatch$.subscribe(
            dispatch => {
                this.selectedDispatch = dispatch;
            }));
    }

    private _mouseEnterStream: EventEmitter<any> = new EventEmitter();
    private _mouseLeaveStream: EventEmitter<any> = new EventEmitter();

    ngOnInit() {
        this.authService.subscribeToLoginEvents((user: UsersBus) => {
            if (user) {
                this.initData();
            }
        });
    }

    ngOnDestroy() {
        this.subscriptions.forEach(subscription => subscription.unsubscribe());
        this.authService.unsubscribeToLoginEvents();
    }


    sch: DispatchBoardSearch = new DispatchBoardSearch(null);
    dataIds: DispatchAssignmentBus[];
    dataDispatches: v_DispatchBus[];
    searchParam: DispatchBoardSearch;
    today: Date;
    weekStart: Date;
    calendarWeek: any = {
        sun: new Date(),
        mon: new Date(),
        tue: new Date(),
        wed: new Date(),
        thu: new Date(),
        fri: new Date(),
        sat: new Date()
    };

    dispatches: any;

    hidePanel: boolean = false;

    showCalendar: boolean = false;

    selectedDispatch: string = '';

    @Output() closed = new EventEmitter<DispatchBoardPanels>();
    public panelTypes = DispatchBoardPanels;
    panelType: DispatchBoardPanels = DispatchBoardPanels.tech;
    @Input() detailData: any = {};
    public contentTypes = WindowContents;
    @Output() openRequest = new EventEmitter<object>();

    initData() {
        this.showCalendar = false;
        this.today = new Date();
        this.findSunday(this.today);
        this.getCalendarDates(this.weekStart);
        this.svc_data.setCalendarWeek(this.calendarWeek);
        this.svc_data.setcalendarSingleDay(new Date());
        this.searchParam = this.sch;
        this.searchParam.userId = this.svc_globals.userId;
        if (this.detailData.personId) {
            this.svc_data.getTechAssignments(this.detailData.personId).subscribe(dataIds => {
                this.dataIds = dataIds;

                if (dataIds && dataIds.error) {
                    console.error(dataIds.error);
                    this.svc_globals.notifyError('Error occurred fetching tech assignments. ' + CommonValues.ErrorMessages_BaseErrorSuffix);
                }

                this.searchParam.assignedDispatches = [];
                if (this.dataIds) {
                    for (var i = 0; i < this.dataIds.length; i++) {
                        this.searchParam.assignedDispatches.push(this.dataIds[i].dispatchId);
                    }
                    this.svc_data.searchParams.assignedDispatches = this.searchParam.assignedDispatches;

                    if (CommonFunctions.hasArrayValue(this.dataIds)) {
                        let arr: DispatchAssignmentBus[] = [];
                        for (let i = 0; i < this.dataIds.length; i++) {
                            arr.push(new DispatchAssignmentBus(this.dataIds[i]));
                        }
                        this.dataIds = arr;
                        this.svc_data.setDispatcAssignmentsForTech(this.dataIds);

                        this.svc_data.GetDispatchesByIdsFilter(this.searchParam).subscribe(dataDispatches => {
                            this.dataDispatches = dataDispatches;

                            if (CommonFunctions.hasArrayValue(this.dataDispatches)) {
                                let arr: v_DispatchBus[] = [];
                                for (let i = 0; i < this.dataDispatches.length; i++) {
                                    arr.push(new v_DispatchBus(this.dataDispatches[i]));
                                }
                                this.dataDispatches = arr;
                                this.svc_data.setDispatchesForTech(this.dataDispatches);

                                this.showCalendar = true;

                                if (dataDispatches && dataDispatches.error) {
                                    alert('got an error back!');
                                }
                            }
                        });
                    }
                }
            });
        }
    }

    closeWindow() {
        this.closed.emit(this.panelTypes.tech);
    }

    public showFilter: boolean = false;

    filter() {
        this.showFilter = !this.showFilter;
    }

    calDateChange(e) {

        var currentTime = new Date(Date.parse(e));

        this.findSunday(currentTime);

        this.getCalendarDates(this.weekStart);
        this.svc_data.setCalendarWeek(this.calendarWeek);
        this.svc_data.setcalendarSingleDay(new Date(Date.parse(e)));
    }

    findSunday(day: Date) {
        let sunday = day;

        switch (day.getDay()) {
            case 0:
                //nothing needed
                break;
            case 1:
                sunday.setDate(sunday.getDate() - 1);
                break;
            case 2:
                sunday.setDate(sunday.getDate() - 2);
                break;
            case 3:
                sunday.setDate(sunday.getDate() - 3);
                break;
            case 4:
                sunday.setDate(sunday.getDate() - 4);
                break;
            case 5:
                sunday.setDate(sunday.getDate() - 5);
                break;
            case 6:
                sunday.setDate(sunday.getDate() - 6);
                break;
        }
        this.weekStart = sunday;
    }

    getCalendarDates(start: Date) {
        let sun = start;
        let mon = new Date();
        mon = addDays(start, 1);
        let tue = new Date();
        tue = addDays(start, 2);
        let wed = new Date();
        wed = addDays(start, 3);
        let thu = new Date();
        thu = addDays(start, 4);
        let fri = new Date();
        fri = addDays(start, 5);
        let sat = new Date();
        sat = addDays(start, 6);

        this.calendarWeek.sun = sun;
        this.calendarWeek.mon = mon;
        this.calendarWeek.tue = tue;
        this.calendarWeek.wed = wed;
        this.calendarWeek.thu = thu;
        this.calendarWeek.fri = fri;
        this.calendarWeek.sat = sat;
    }
    onMouseEnter(e) {
        //this.mouseLeft = false;
        this._mouseEnterStream.emit(e);
    }

    onMouseLeave(e) {
        //this.mouseLeft = true;
        this._mouseLeaveStream.emit(e);
    }

    mouseOver(e, hover) {

    }

    openWindow(dispatch, trigger) {
        let passedData;
        let windowData;
        switch (trigger) {
            case 1:
                passedData = { data: this.svc_data.statusList, moveDispatch: dispatch };
                windowData = { contentType: this.contentTypes.moveStatus, boardData: passedData };

                this.openRequest.emit(windowData);
                break;
            case 2:
                passedData = { data: this.svc_data.techList, assignDispatch: dispatch };
                windowData = { contentType: this.contentTypes.assignTech, boardData: passedData };

                this.openRequest.emit(windowData);
                break;
            case 3:
                passedData = { data: {}, viewDispatch: dispatch };
                windowData = { contentType: this.contentTypes.viewDispatch, boardData: passedData };

                this.openRequest.emit(windowData);
                break;
        }

    }

    setSelectedDispatch(dispatch: v_DispatchGrid2Bus) {

        this.svc_data.setSelectedDispatch(dispatch.dispatchId);
    }
}
